import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancel: {
    description: 'genericErrorRetryContainer.cancel',
    defaultMessage: 'Cancel',
    id: 'MMNSBN',
  },
  tryAgain: {
    description: 'genericErrorRetryContainer.tryAgain',
    defaultMessage: 'Try Again',
    id: 's9D8X8',
  },
});
